/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Parser from 'html-react-parser';

class MainMenuItems extends Component {
  	render() {
  		const { mainMenu, classNameUL } = this.props;
	    return (
			<ul className={classNameUL !== undefined ? classNameUL : ''}>
				{mainMenu.map( (menu) =>
			        <li key={menu.ID}><a href={menu.url}>{Parser(menu.title)}</a></li>
			    )}
			</ul>
	    );
  	}
}
export default MainMenuItems;